import React, { useState } from 'react';
import { authService } from '../services/auth';
import { toast } from 'react-toastify';
import './Login.css';

const Login = ({ onSuccess, onRegisterClick, onBackToLanding }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const [loginError, setLoginError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            setLoginError(null);
            const res = await authService.login({ email, password });
            const { token, user } = res;
            authService.saveSession(token, user);
            toast.success('Ingreso exitoso');
            if (onSuccess) onSuccess(user);
        } catch (err) {
            const message = err?.response?.data?.error || err.message || 'Error al iniciar sesión';
            setLoginError(message);
            toast.error(message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-form">
            <button type="button" className="btn-back" onClick={onBackToLanding}>
                ← Volver al inicio
            </button>
            
            <h2>Iniciar sesión</h2>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label>Email</label>
                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                </div>
                <div className="form-group">
                    <label>Contraseña</label>
                    <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                </div>
                <button type="submit" disabled={loading} className="btn-primary">
                    {loading ? 'Ingresando...' : 'Ingresar'}
                </button>
                {loginError === 'Email no verificado' && (
                    <div className="form-group">
                        <p>Tu correo no ha sido verificado. ¿No recibiste el email?</p>
                        <button
                            type="button"
                            className="btn-secondary"
                            onClick={async () => {
                                try {
                                    setLoading(true);
                                    await authService.resendVerification(email);
                                    toast.success('Email de verificación reenviado');
                                } catch (err) {
                                    toast.error(err?.response?.data?.error || err.message || 'Error al reenviar');
                                } finally {
                                    setLoading(false);
                                }
                            }}
                        >
                            Reenviar email de verificación
                        </button>
                    </div>
                )}

                <p className="auth-footer">
                    ¿No tienes cuenta?{' '}
                    <span onClick={onRegisterClick}>Crea una aquí</span>
                </p>
            </form>
        </div>
    );
};

export default Login;
